"use client"

import { useEffect, useState } from "react"
import { sendGTMEvent } from "@next/third-parties/google"

import { generatePageTypeTrackingData } from "@/lib/gtmTrackingHelper"
import { CommonPageContext } from "@/lib/tracking/tracking"

export interface ContentPageTrackingClientProps {
  commonPageContext: CommonPageContext
  page_type: string
}

export default function ContentPageTrackingClient(props: ContentPageTrackingClientProps) {
  const [tracked, setTracked] = useState(false)

  useEffect(() => {
    if (!tracked) {
      sendGTMEvent(
        generatePageTypeTrackingData(
          props.commonPageContext.isAnonymous,
          props.commonPageContext.isB2B,
          props.page_type
        )
      )

      setTracked(true)
    }
  }, [props.commonPageContext, props.page_type, tracked])

  return <span className="PageType hidden">{props.page_type}</span>
}
